import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import MobileTopBar from "@/components/MobileTopBar";
import DemoTour from "@/components/DemoTour";
import CommandPalette from "@/components/CommandPalette";
import ImpersonationBanner from "@/components/ImpersonationBanner";

export default function AppLayout() {
  return (
    <div className="min-h-screen bg-paper flex">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <ImpersonationBanner />
        <MobileTopBar />
        <main className="flex-1 overflow-y-auto" data-testid="app-main">
          <Outlet />
        </main>
      </div>
      <DemoTour />
      <CommandPalette />
    </div>
  );
}
